(function () {
  const cache = new Map();
  const parser = new DOMParser();
  const DEFAULT_SECTION_ID = 'main-product-large-image-v0';

  /**
   * @param {string} handle
   * @param {string|number} productId
   * @param {string} [sectionId] Theme section file name (e.g. main-product-large-image-v0)
   * @returns {Promise<object|null>}
   */
  async function fetchData(handle, productId, sectionId) {
    if (!handle) return null;

    const resolvedSectionId = sectionId || DEFAULT_SECTION_ID;
    const cacheKey = `${handle}::${resolvedSectionId}`;

    if (cache.has(cacheKey)) return cache.get(cacheKey);

    const promise = fetch(
      `/products/${encodeURIComponent(handle)}?section_id=${encodeURIComponent(resolvedSectionId)}`,
      {
        headers: { Accept: 'text/html' },
      }
    )
      .then((response) => {
        if (!response.ok) throw new Error(`Section fetch failed: ${response.status}`);
        return response.text();
      })
      .then((html) => {
        let markup = html.trim();
        if (markup.startsWith('{')) {
          try {
            markup = Object.values(JSON.parse(markup))[0];
          } catch (_) {
            /* use raw markup */
          }
        }
        const doc = parser.parseFromString(markup, 'text/html');
        const node =
          doc.querySelector(`#QuickViewData-${productId}`) ||
          doc.querySelector('[data-quick-view-data]');
        if (!node) throw new Error('QuickViewData tag missing');
        return JSON.parse(node.textContent);
      })
      .catch((err) => {
        cache.delete(cacheKey);
        throw err;
      });

    cache.set(cacheKey, promise);
    return promise;
  }

  window.QuickView = Object.assign(window.QuickView || {}, { fetchData });
})();
